import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields, Button } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";
import { CancelarFactura } from "../cancelacion";
import { GenerarNotaDeCreditoModalEdit } from "../notacredito";
import { EnviarCorreoModalEdit } from "../correo";
import { DoctoEdit } from "../rep";
import { FiltroFacturaComponent } from "./filtro";
import * as globals from "app/resources/globals";
import { MultiCancelacionModal } from "../cancelacionmultiple/modal"

type Entity = models.FacturaDto;
import { columnas } from "./columns";
const resource = resources.Factura;
interface Props {
    permisos: models.Rol;
    filtro: models.FiltroFacturas;
    onFiltroChange: (x: models.FiltroFacturas) => void;
}

class FacturaListCompNoRx extends React.PureComponent<Props> {
    modalManager = kea.createModalManager();

    onEliminar = async (x: Entity) => {
        if (await kea.yesno("Eliminar factura?", "" + x.SerieFolio)) {
            await resource.delete(x.IdRegistro);
            await kea.message("La factura ha sido eliminada");
        }
    }

    onTimbrar = async (x: Entity) => {
        if (await kea.yesno("¿Timbrar factura?", "" + x.SerieFolio)) {
            if (x.ImporteTotal > 0) {
                await resource.TimbrarFactura(x.IdRegistro);
                await kea.message("La factura ha sido timbrada");
            } else {
                await kea.message("Factura en cero", "No se puede timbrar la factura debido a que no tiene ningún importe", "error");
            }
        }
    }

    OnObtenerXML = async (x: Entity) => {
        if (await kea.yesno("¿Obtener XML de la factura?", "" + x.SerieFolio)) {
            const comprobanteXML = await resource.ObtenerXML(x.IdRegistro);
            kea.download(kea.base64ToBlob(comprobanteXML, 'application/xml'), "Comprobante.xml");
        }
    }

    OnObtenerPDF = async (x: Entity) => {
        if (await kea.yesno("¿Obtener pdf de la factura?", "" + x.SerieFolio)) {
            const facturaPDF = await resource.ObtenerPDF(x.IdRegistro);
            kea.download(kea.base64ToBlob(facturaPDF, 'application/pdf'), "Comprobante.pdf");
        }
    }

    OnObtenerPDFSinTimbrar = async (x: Entity) => {
        if (await kea.yesno("¿Obtener pdf de la factura sin timbrar?", "" + x.SerieFolio)) {
            const facturaPDF = await resources.Factura.GetReporteContrarecibo(x.IdRegistro);
            kea.download(kea.base64ToBlob(facturaPDF, 'application/pdf'), "Comprobante Sin timbrar.pdf");
        }
    }

    RegenerarPolizaContable = async (x: Entity) => {
        if (await kea.yesno("Regenerar poliza contable de cancelación de la factura?", "" + x.SerieFolio)) {
            await resource.GenerarPolizaCancelacion(x.IdRegistro);
            await kea.message("Regeneración de poliza contable de cancelación realizada");
        }
    }

    onGenerarNotaCredito = async (x: Entity) => {
        if (await kea.yesno("¿Generar nota de crédito para esta factura?", "" + x.SerieFolio)) {
            var idRegistro = await resource.GenerarNotaCredito(x.IdRegistro);
            history.go(`./${idRegistro}`);
        }
    }

    onGenerarNotaDeCargo = async () => {
        if (await kea.yesno("¿Generar nota de cargo?")) {
            history.go('./newNC')
        }
    }

    onAgregarNotaCredito = async () => {
        const result = await this.modalManager.showModal(GenerarNotaDeCreditoModalEdit, this.props.filtro, null as any as number);
        if (result.result) {
            const idRegistro = await resource.GenerarNotaCredito(result.value);
            history.go(`./${idRegistro}`);
        }
    }

    onCancelarFacturas = async () => {
        const result = await this.modalManager.showModal(MultiCancelacionModal, null, null);
    }

    onCancelarFacturasfijas = async () => {
        if (await kea.yesno("¿Cancelar las facturas fijas que están en el sistema?"))
            resources.Factura.CancelarFacturasEspecificas();
    }

    onCancelar = async (x: Entity) => {
        await CancelarFactura(x.IdRegistro, this.modalManager.showModal);
    }

    EnviarCorreo = async (x: Entity) => {
        const correo = x.CorreoClienteFacturacion || "";
        const result = await this.modalManager.showModal(EnviarCorreoModalEdit, undefined, correo);
        if (result.result) {
            const enviado = await resource.EnviarCorreo(x.IdRegistro, result.value);
            if (enviado)
                await kea.message("Correo enviado");
            else
                await kea.message("Correo no enviado", "Revisar la configuración de cliente smtp ó la dirección correo de destino de la factura", "error");
        }
    }

    onCorregirFactura = async (x: Entity) => {
        if (await kea.yesno("Se cancelará esta factura y se creará una nueva?", x.SerieFolio)) {
            const idNuevaFactura = await resource.CorregirFacturaCobranza(x.IdRegistro);
            history.go(`./${idNuevaFactura}`);
        }
    }

    OnDuplicarFactura = async (x: Entity) => {
        const id = await resources.Factura.DuplicarFactura(x.IdRegistro);
        const nuevaFactura = await resources.Factura.get(id);
        await kea.message("Se duplicó la factura " + x.SerieFolio, "La nueva factura es " + nuevaFactura.SerieFolio);
    }

    onEdit = (x: Entity) => history.go(`./${x.IdRegistro}`);
    onAgregar = () => history.go('./new');
    onRegresar = () => history.go('../');

    permisoCapturar = (x: Props) => x.permisos.Facturas.VerCrearFacturaArbitraria;
    permisoGenerarNotaCredito = (x: Props) => x.permisos.Facturas.VerGenerarNotaDeCredito;
    permisoGenerarNotaCargo = (x: Props) => x.permisos.Facturas.VerGenerarNotaDeCargo;
    permisoCancelarFactura = (x: Props) => x.permisos.Facturas.CancelarFactura;
    permisoVerBotonCancelarMultiFacturas = (x: Props) => x.permisos.Facturas.VerBotonCancelarMultiFacturas;

    private filtro = (props: Props) => props.filtro;

    private facturas = createSelectorRx(this.filtro, filtro => {
        const obs = observeResource(resource.Query, { ...filtro, EsREP: false });
        return obs;
    });


    limpiarfiltros = (x: Props) => {

        x.filtro.DeCredito= null
        x.filtro.EsCancelada= null
        x.filtro.EsNotaCargo= null
        x.filtro.EsNotaCredito= null
        x.filtro.EsREP= false
        x.filtro.EsTimbrada= null
        x.filtro.FechaCancelacionFinal= null
        x.filtro.FechaCancelacionInicio= null
        x.filtro.FechaFinal= null
        x.filtro.FechaInicio= null
        x.filtro.IdCliente= null
        x.filtro.IdSucursal= null
        x.filtro.Limite= 100
        x.filtro.Origen= null
        x.filtro.SerieFolio= ""

        x.onFiltroChange(x.filtro)
    
        location.reload();
    }



    render() {
        const cols = columnas(this, this.props.permisos);
        const puedeCapturar = this.permisoCapturar(this.props);
        const filtro = this.filtro(this.props);
        const facturas = this.facturas(this.props);
        const puedeGenerarNotaCredito = this.permisoGenerarNotaCredito(this.props);
        const puedeGenerarNotaCargo = this.permisoGenerarNotaCargo(this.props);
        const permisoCancelarFactura = this.permisoCancelarFactura(this.props);
        const permisoVerBotonCancelarMultiFacturas = this.permisoVerBotonCancelarMultiFacturas(this.props);
        return (
            <div>
                <kea.Title titulo="Facturas" onRegresar={this.onRegresar}  >
                    {
                        puedeCapturar &&
                        <kea.AgregarButton onClick={this.onAgregar} />
                    }
                    {
                        puedeGenerarNotaCredito &&
                        <kea.Button style="success" onClick={this.onAgregarNotaCredito} children="Agregar Nota de crédito" tooltip="Generar una nota de crédito a partir de varias facturas" />
                    } {
                        puedeGenerarNotaCargo &&
                        <kea.Button iconClass={fa("tasks")} tooltip="Agregar una nota de cargo" children="Nota de cargo" style="primary" onClick={this.onGenerarNotaDeCargo} />
                    }
                    {
                        permisoCancelarFactura &&
                        <kea.Button iconClass={fa("times-circle-o")} tooltip="Cancelar multiples facturas" children="Cancelar facturas" style="warning" onClick={this.onCancelarFacturas} />
                    }
                    {
                        permisoVerBotonCancelarMultiFacturas &&
                        <kea.Button iconClass={fa("times-circle-o")} tooltip="Cancelar facturas fijas" children="Cancelar facturas fijas" style="danger" onClick={this.onCancelarFacturasfijas} />
                    }
                    {
                        <kea.Button children="Limpiar campos" style="default" onClick={() => this.limpiarfiltros(this.props)} />
                    }

                    
                </kea.Title>
                <FiltroFacturaComponent value={filtro} onChange={this.props.onFiltroChange} />
                <kea.Grid2 columnas={cols} cookieKey={"FacturaListCookieKey"} items={facturas} getKey={x => x.IdRegistro} />
                {this.modalManager.component}
            </div>
        )
    }
}

const FacturaListComp = componentToRx(FacturaListCompNoRx);

export class FacturaList extends React.PureComponent {
    render() {
        return (
            <FacturaListComp
                permisos={resources.User.PermisoRx}
                filtro={globals.state.map(x => x.filtroFacturas)}
                onFiltroChange={x => globals.setState({ filtroFacturas: x })}
            />
        )
    }
}


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/facturas/list/list.tsx